import { AutogenLayoutOffice401kHistoryList } from "./autogen/AutogenLayoutOffice401kHistoryList";

export class Office401kHistoryList extends AutogenLayoutOffice401kHistoryList {
    
}
